function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["selection"],
  _excluded2 = ["init", "bind", "empty"],
  _excluded3 = ["transform"],
  _excluded4 = ["selection"],
  _excluded5 = ["selection"],
  _excluded6 = ["selection", "param", "test"],
  _excluded7 = ["selection", "param", "test"],
  _excluded8 = ["selection"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { isArray } from 'vega-util';
import { isBinParams } from '../bin';
import { isConditionalDef, isFieldDef, isScaleFieldDef } from '../channeldef';
import { normalizeLogicalComposition } from '../logical';
import { SpecMapper } from '../spec/map';
import { isBin, isFilter, isLookup } from '../transform';
import { duplicate, entries, vals } from '../util';
export var SelectionCompatibilityNormalizer = /*#__PURE__*/function (_SpecMapper) {
  function SelectionCompatibilityNormalizer() {
    _classCallCheck(this, SelectionCompatibilityNormalizer);
    return _callSuper(this, SelectionCompatibilityNormalizer, arguments);
  }
  _inherits(SelectionCompatibilityNormalizer, _SpecMapper);
  return _createClass(SelectionCompatibilityNormalizer, [{
    key: "map",
    value: function map(spec, normParams) {
      var _normParams$emptySele, _normParams$selection;
      (_normParams$emptySele = normParams.emptySelections) !== null && _normParams$emptySele !== void 0 ? _normParams$emptySele : normParams.emptySelections = {};
      (_normParams$selection = normParams.selectionPredicates) !== null && _normParams$selection !== void 0 ? _normParams$selection : normParams.selectionPredicates = {};
      spec = normalizeTransforms(spec, normParams);
      return _superPropGet(SelectionCompatibilityNormalizer, "map", this, 3)([spec, normParams]);
    }
  }, {
    key: "mapLayerOrUnit",
    value: function mapLayerOrUnit(spec, normParams) {
      spec = normalizeTransforms(spec, normParams);
      if (spec.encoding) {
        var encoding = {};
        var _iterator = _createForOfIteratorHelper(entries(spec.encoding)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ref = _step.value;
            var _ref2 = _slicedToArray(_ref, 2);
            var channel = _ref2[0];
            var enc = _ref2[1];
            encoding[channel] = normalizeChannelDef(enc, normParams);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        spec = _objectSpread(_objectSpread({}, spec), {}, {
          encoding: encoding
        });
      }
      return _superPropGet(SelectionCompatibilityNormalizer, "mapLayerOrUnit", this, 3)([spec, normParams]);
    }
  }, {
    key: "mapUnit",
    value: function mapUnit(spec, normParams) {
      var selection = spec.selection,
        rest = _objectWithoutProperties(spec, _excluded);
      if (selection) {
        return _objectSpread(_objectSpread({}, rest), {}, {
          params: entries(selection).map(function (_ref3) {
            var _normParams$selection2;
            var _ref4 = _slicedToArray(_ref3, 2),
              name = _ref4[0],
              selDef = _ref4[1];
            var value = selDef.init,
              bind = selDef.bind,
              empty = selDef.empty,
              select = _objectWithoutProperties(selDef, _excluded2);
            if (select.type === 'single') {
              select.type = 'point';
              select.toggle = false;
            } else if (select.type === 'multi') {
              select.type = 'point';
            }
            // Propagate emptiness forwards and backwards
            normParams.emptySelections[name] = empty !== 'none';
            var _iterator2 = _createForOfIteratorHelper(vals((_normParams$selection2 = normParams.selectionPredicates[name]) !== null && _normParams$selection2 !== void 0 ? _normParams$selection2 : {})),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var pred = _step2.value;
                pred.empty = empty !== 'none';
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            return {
              name: name,
              value: value,
              select: select,
              bind: bind
            };
          })
        });
      }
      return spec;
    }
  }]);
}(SpecMapper);
function normalizeTransforms(spec, normParams) {
  var tx = spec.transform,
    rest = _objectWithoutProperties(spec, _excluded3);
  if (tx) {
    var transform = tx.map(function (t) {
      if (isFilter(t)) {
        return {
          filter: normalizePredicate(t, normParams)
        };
      } else if (isBin(t) && isBinParams(t.bin)) {
        return _objectSpread(_objectSpread({}, t), {}, {
          bin: normalizeBinExtent(t.bin)
        });
      } else if (isLookup(t)) {
        var _t$from = t.from,
          param = _t$from.selection,
          from = _objectWithoutProperties(_t$from, _excluded4);
        return param ? _objectSpread(_objectSpread({}, t), {}, {
          from: _objectSpread({
            param: param
          }, from)
        }) : t;
      }
      return t;
    });
    return _objectSpread(_objectSpread({}, rest), {}, {
      transform: transform
    });
  }
  return spec;
}
function normalizeChannelDef(obj, normParams) {
  var _enc$scale;
  var enc = duplicate(obj);
  if (isFieldDef(enc) && isBinParams(enc.bin)) {
    enc.bin = normalizeBinExtent(enc.bin);
  }
  if (isScaleFieldDef(enc) && (_enc$scale = enc.scale) !== null && _enc$scale !== void 0 && (_enc$scale = _enc$scale.domain) !== null && _enc$scale !== void 0 && _enc$scale.selection) {
    var _enc$scale$domain = enc.scale.domain,
      param = _enc$scale$domain.selection,
      domain = _objectWithoutProperties(_enc$scale$domain, _excluded5);
    enc.scale.domain = _objectSpread(_objectSpread({}, domain), param ? {
      param: param
    } : {});
  }
  if (isConditionalDef(enc)) {
    if (isArray(enc.condition)) {
      enc.condition = enc.condition.map(function (c) {
        var selection = c.selection,
          param = c.param,
          test = c.test,
          cond = _objectWithoutProperties(c, _excluded6);
        return param ? c : _objectSpread(_objectSpread({}, cond), {}, {
          test: normalizePredicate(c, normParams)
        });
      });
    } else {
      var _normalizeChannelDef = normalizeChannelDef(enc.condition, normParams),
        selection = _normalizeChannelDef.selection,
        _param = _normalizeChannelDef.param,
        test = _normalizeChannelDef.test,
        cond = _objectWithoutProperties(_normalizeChannelDef, _excluded7);
      enc.condition = _param ? enc.condition : _objectSpread(_objectSpread({}, cond), {}, {
        test: normalizePredicate(enc.condition, normParams)
      });
    }
  }
  return enc;
}
function normalizeBinExtent(bin) {
  var ext = bin.extent;
  if (ext !== null && ext !== void 0 && ext.selection) {
    var param = ext.selection,
      rest = _objectWithoutProperties(ext, _excluded8);
    return _objectSpread(_objectSpread({}, bin), {}, {
      extent: _objectSpread(_objectSpread({}, rest), {}, {
        param: param
      })
    });
  }
  return bin;
}
function normalizePredicate(op, normParams) {
  // Normalize old compositions of selection names (e.g., selection: {and: ["one", "two"]})
  var normalizeSelectionComposition = function normalizeSelectionComposition(o) {
    return normalizeLogicalComposition(o, function (param) {
      var _normParams$emptySele2, _a$param;
      var _a;
      var empty = (_normParams$emptySele2 = normParams.emptySelections[param]) !== null && _normParams$emptySele2 !== void 0 ? _normParams$emptySele2 : true;
      var pred = {
        param: param,
        empty: empty
      };
      (_a$param = (_a = normParams.selectionPredicates)[param]) !== null && _a$param !== void 0 ? _a$param : _a[param] = [];
      normParams.selectionPredicates[param].push(pred);
      return pred;
    });
  };
  return op.selection ? normalizeSelectionComposition(op.selection) : normalizeLogicalComposition(op.test || op.filter, function (o) {
    return o.selection ? normalizeSelectionComposition(o.selection) : o;
  });
}